(function () {
  function initTerozBanner() {
    const banner = document.querySelector('.teroz-banner');
    if (!banner) return;

    const bg = banner.querySelector('.teroz-banner__bg');
    const content = banner.querySelector('.teroz-banner__content');

    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;

    const intensityBg = 300;
    const intensityContent = 25;

    function animate() {
      currentX += (targetX - currentX) * 1;
      currentY += (targetY - currentY) * 1;

      bg.style.transform = `
        translate(${currentX * intensityBg}px, ${currentY * intensityBg}px)
        scale(1.15)
      `;

      content.style.transform = `
        translate(${-currentX * intensityContent}px, ${-currentY * intensityContent}px)
      `;

      requestAnimationFrame(animate);
    }

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

window.addEventListener('mousemove', (e) => {
  targetX = clamp(e.clientX / window.innerWidth - 0.5, -0.4, 0.4);
  targetY = clamp(e.clientY / window.innerHeight - 0.5, -0.4, 0.4);
});


    animate();
  }

  document.addEventListener('DOMContentLoaded', initTerozBanner);
})();
